import { render, staticRenderFns } from "./action-sheet-content.vue?vue&type=template&id=d068a54a&scoped=true&"
import script from "./action-sheet-content.vue?vue&type=script&lang=js&"
export * from "./action-sheet-content.vue?vue&type=script&lang=js&"
import style0 from "./action-sheet-content.vue?vue&type=style&index=0&id=d068a54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d068a54a",
  null
  
)

/* custom blocks */
import block0 from "../locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fauctions%2Fcomponents%2Faction-sheet-content.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports